import { Pipe, PipeTransform } from '@angular/core';
import { paddTo } from '../../lib/padd-to';

@Pipe({
  name: 'timeRemaining',
  standalone: true,
})
export class TimeRemainingPipe implements PipeTransform {
  transform(value: number): string {
    if (value === undefined) return '';
    const ms = value;

    const seconds = ms / 1000;
    const minutes = seconds / 60;
    const hours = Math.floor(minutes / 60);

    // 00:00:00

    const values = [Math.floor(minutes % 60), Math.floor(seconds % 60)];
    if (hours) {
      values.unshift(hours);
    }

    return values
      .map((v, i) => {
        return paddTo(v.toString(), i === 0 ? 1 : 2);
      })
      .join(':');
  }
}
